import './data/actions'
import './data/data'
import './data/dispatcher'
import './data/store'
import './steps/HasJobBeenDoneYet'
import './steps/HowMuchDidYouPay'
import './steps/JobStatusUpdated'
import './steps/RateExperience'
import './steps/SubmitFeedback'
import './steps/WhoDidTheJob'
import './CloseModalWarning'
import './Form'
import './Header'
import './NavigationButtons'
import './ProgressBar'
import './Step'
import './StepSequence'
import './Wizard'
import ClosureSurvey from './registry'

export default ClosureSurvey
